import { useState, useEffect } from 'react'
import { UAParser } from 'ua-parser-js'

const useDeviceType = () => {
  const [deviceType, setDeviceType] = useState('desktop')

  useEffect(() => {
    const detectDeviceType = () => {
      const hasTouchScreen = window.matchMedia('(pointer: coarse)').matches

      if (hasTouchScreen) {
        const parser = new UAParser()
        const device = parser.getDevice()
        const os = parser.getOS()

        if (
          device.type === 'mobile' ||
          os.name === 'Android' ||
          os.name === 'iOS' ||
          /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent,
          )
        ) {
          setDeviceType('mobile')
        } else {
          setDeviceType('tablet')
        }
      } else {
        setDeviceType('desktop')
      }
    }

    detectDeviceType()

    window.addEventListener('resize', detectDeviceType)

    return () => {
      window.removeEventListener('resize', detectDeviceType)
    }
  }, [])

  return deviceType
}

export default useDeviceType
